<template>
  <div class="unavailable">
    <div class="unavailable-wrapper" v-show="recordsList.length">
      <list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <div :key="index" class="unavailable-list" v-for="(record, index) in recordsList">
          <a @click="jumpDetails" class="jump-details" href="javascript:;">
            <div class="desc">
              <div class="icon">
                <img alt src="../../assets/img/red-bag.png" />
              </div>
              <div class="intro">
                <p>{{record.sku_name}}</p>
                <p>{{record.exp_at}}</p>
              </div>
            </div>
            <div class="price">
              <em>{{record.price}}</em>
            </div>
          </a>
        </div>
      </list>
    </div>
    <nodata v-show="!recordsList.length && noRecords"></nodata>
  </div>
</template>

<script>
import Nodata from './NoData'
import { List } from 'vant'
let flag = false
export default {
  name: 'unavailable',
  components: {
    Nodata,
    List
  },
  data () {
    return {
      recordsList: [],
      noRecords: false,
      pageNum: 1,
      loading: false,
      finished: false
    }
  },
  created () {
    this.$toast.loading({
      message: '正在加载...',
      duration: 300000
    })
    this.getRecords()
  },
  methods: {
    onLoad () {
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.getRecords(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 500)
    },
    jumpDetails () { },
    async getRecords (pageNum) {
      const res = await this.$axios.get(`api/member/reward/${pageNum || 1}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          this.recordsList = [...this.recordsList, ...data]
        } else if (code === 9006) {
          if (this.pageNum === 1) {
            this.noRecords = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.unavailable-wrapper {
  padding: 0.5rem 0.25rem;
  background-color: #fff;
}
.unavailable-list {
  height: 1.7rem;
  margin-bottom: 0.33rem;
  font-size: @fz22;
  border-radius: 0.23rem;
  background-color: #fff8db;
  &:last-child {
    margin-bottom: 0;
  }
  .jump-details {
    padding: 0 0.2rem;
    height: 100%;
    .flex-between;
    .desc {
      display: flex;
      align-items: center;
      .icon {
        width: 0.91rem;
        height: 1.11rem;
      }
      .intro {
        width: 3.6rem;
        height: 1.1rem;
        .flex-column-between;
        padding-left: 0.23rem;
        color: #d37c00;
        font-size: @fz22;
        p:nth-child(1) {
          .ellipsis2;
          line-height: 1.1;
        }
        p:nth-child(2) {
          white-space: nowrap;
        }
      }
    }
    .price {
      color: @price;
      em {
        font-size: 0.42rem;
        padding-right: 0.1rem;
      }
    }
  }
}
</style>
